<template>
  <v-app v-if="userUid && userData">
    <v-navigation-drawer
      persistent
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <v-img :aspect-ratio="16/9" :src="require('@/assets/ng-background-blue.png')">
        <v-layout pa-2 column fill-height class="lightbox white--text">
          <v-spacer></v-spacer>
          <v-flex shrink>
            <div class="subheading">{{ userData.name }} {{ userData.lastname }}</div>
            <div class="body-1">{{ userData.email }}</div>
          </v-flex>
        </v-layout>
      </v-img>
      <v-list>
        <v-select
          :items="availableClients"
          label="Current client"
          item-text="name"
          item-value="id"
          v-model="currentClient"
          @change="currentClientChanged"
        ></v-select>
        <v-list-group no-action prepend-icon="info" value="true">
          <v-list-tile slot="activator">
            <v-list-tile-title>Data</v-list-tile-title>
          </v-list-tile>
          <v-list-tile :to="{path: 'files'}">
            <v-list-tile-title>Files</v-list-tile-title>
          </v-list-tile>
        </v-list-group>
        <v-list-group no-action prepend-icon="insert_chart" value="true" v-if="userData.admin">
          <v-list-tile slot="activator">
            <v-list-tile-title>Admin</v-list-tile-title>
          </v-list-tile>
          <v-list-tile :to="{path: 'clients'}">
            <v-list-tile-title>Clients</v-list-tile-title>
          </v-list-tile>
          <v-list-tile :to="{path: 'users'}">
            <v-list-tile-title>Users</v-list-tile-title>
          </v-list-tile>
        </v-list-group>
        <v-list-tile @click="logout" color="red" style="padding-left: 56px;">
          <v-list-tile-title>Logout</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      app
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <img height="45px" src="@/assets/logo.png" alt="NoiseGrasp">
      <v-toolbar-title v-text="$route.name"></v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-fade-transition mode="out-in">
        <router-view/>
      </v-fade-transition>
    </v-content>
  </v-app>
  <v-app v-else-if="loginRequired">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Login</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field prepend-icon="person" name="email" label="E-mail" type="text" v-model="email" v-on:keyup.enter="_login"></v-text-field>
                  <v-text-field id="password" prepend-icon="lock" name="password" label="Password" type="password" v-model="password" v-on:keyup.enter="_login"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="_login">Login</v-btn>
              </v-card-actions>
            </v-card>
            <v-alert v-if="error" :value="true" type="error">
              {{ error }}
            </v-alert>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
  <v-app v-else>
    <v-content>
      <v-progress-linear :indeterminate="true"></v-progress-linear>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'App',
  data () {
    return {
      email: '',
      password: '',
      error: null,
      drawer: true,
      right: true,
      rightDrawer: false,
      currentClient: null
    }
  },
  components: {
    
  },
  computed: {
    ...mapGetters([
      'userUid',
      'userData',
      'loginRequired',
      'allClients',
      'userCurrentClient',
    ]),
    availableClients() {
      if (this.allClients.length > 0) {
        return this.allClients
      } else {
        var clients = this.userData.clients.map(function (obj) {
          return obj.client
        })
        return clients
      }
    }
  },
  methods: {
    ...mapActions([
      'login',
      'logout',
      'initStore',
    ]),
    currentClientChanged: function () {
      this.$store.commit('set_current_client', this.currentClient)
      this.initStore()
    },
    _login: function () {
      // Always reset error state when trying to login
      this.error = null
      this.login({
        user: this.email,
        password: this.password
      }).then((error) => {
        if (error) {
          this.error = error.message
        } else {
          // Only forget email when a login attempt is successful 
          this.email = ''
        }
      })
      // Always forget password when trying to login
      this.password = ''
    }
  },
  watch: {
    userUid: {
      immediate: true,
      handler () {
        if (this['userUid']) {
          this.initStore()
        }
      }
    },
    userCurrentClient: {
      immediate: true,
      handler () {
        console.log(this.userCurrentClient)
        if (this.userCurrentClient && 'id' in this.userCurrentClient) {
          this.currentClient = this.userCurrentClient.id
        }
      }
    }
  }
}
</script>
